import { createFileRoute, useNavigate } from '@tanstack/react-router'
import type { JSX } from 'react'

import {
  AlertRulesScreen,
  BIN_MCC_REPORT_PATH
} from './-components/alert-rules-screen.tsx'

export const Route = createFileRoute('/alerts/rules')({
  component: AlertRulesPage
})

function AlertRulesPage(): JSX.Element {
  const navigate = useNavigate()

  return (
    <AlertRulesScreen
      onOpenReport={() => {
        void navigate({ to: BIN_MCC_REPORT_PATH })
      }}
    />
  )
}
